import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";

function Strength() {
  const strengthRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -20px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Adding animate-in to Strength:', entry.target.className);
          entry.target.classList.add('animate-in');
        } else {
          console.log('Removing animate-in from Strength:', entry.target.className);
          entry.target.classList.remove('animate-in');
        }
      });
    }, observerOptions);

    if (strengthRef.current) {
      observer.observe(strengthRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const equipmentList = [
    "FLUKE 열화상 카메라",
    "FLUKE 멀티 테스터",
    "TESTO 디지털 메니폴드",
    "TESTO 공기질 측정기",
    "TESTO 산소 측정기",
    "TESTO 풍력/풍압 측정기",
    "TESTO 유도 모터 검상/검선기",
    "BLUETEC+ 토크렌치"
  ];

  return (
    <section ref={strengthRef} className="strength-section scroll-animate">
      <Container>
        <div className="strength-content">
          <div className="strength-title-section">
            <h1 className="strength-title">동진에어텍의 강점</h1>
          </div>

          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="strength-description">
                <p>동진에어텍은 엔지니어의 경험에만 머물지 않습니다.</p>
                <p>장비의 디지털화를 시행하고 데이터 베이스를 축적하여 가장 적절한 대처를 하고 있습니다.</p>
              </div>

              <div className="strength-equipment">
                <h3 className="equipment-subtitle">보유 HVAC 장비</h3>
                <div className="equipment-grid">
                  {equipmentList.map((equipment, index) => (
                    <div key={index} className="equipment-item">
                      <span className="equipment-bullet">•</span>
                      <span className="equipment-name">{equipment}</span>
                    </div>
                  ))}
                </div>

                <div className="strength-footer">
                  <p>
                    디월트 XR 전동공구 등 수공구를 제외한 모든 계측기는 정형화된 보고서 양식으로 사용자에게 제공되며,
                    모든 결과는 당사에 동시 보관되어 집니다.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Strength;